import React from 'react';

export const TermsOfService = () => {
  return (
    <>
      <a
        href="https://www.safariportal.app/terms-of-service"
        target="_blank"
        rel="noopener noreferrer"
        className="link"
        children="Terms of Use"
      />{' '}
      and{' '}
      <a
        href="https://www.safariportal.app/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="link"
        children="Privacy Policy"
      />
    </>
  );
};
